exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body .ui-datatable .ui-datatable-thead > tr > th,\r\nbody .ui-datatable .ui-datatable-tfoot > tr > td {\r\n    padding: 0.5em;\r\n}\r\n\r\nbody .ui-datatable .ui-datatable-data > tr > td {\r\n    padding: .5em;\r\n}\r\n\r\n.ui-datatable-scrollable-header-box{\r\n    margin-right: 15px!important;\r\n    }\r\n\r\n    .ui-datatable-scrollable-body {\r\n    overflow-y: scroll !important;\r\n    }\r\n\r\n    .ui-datatable-scrollable-header {\r\n    width: 100% !important;\r\n    }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/electricity/electricity-dashboard/electricity-dashboard.component.css
// module id = 664
// module chunks = 0